import axios from 'axios';

class Note {
    constructor(uuid, user, note, date, noteTypeId, deleted, userId) {
        this.uuid = uuid;
        this.user = user;
        this.note = note;
        this.date = date;
        this.noteTypeId = noteTypeId;
        this.deleted = deleted;
        this.userId = userId;
    }
}

class NoteType {
    constructor(uuid, name) {
        this.uuid = uuid;
        this.name = name;
    }
}

export default class ClientNotesService {

    getNoteType() {

        return new Promise( (resolve, reject) => {

            const url = 'clients/notesType';

            axios.get(url)
                .then((response) => {

                    if (response.status === 200) {

                        let notesType = [];

                        response.data.forEach((noteType) => {
                            notesType.push(new NoteType(noteType.uuid, noteType.name));
                        });

                        resolve(notesType);
                    }
                    else {
                        reject(response.status);
                    }
                })
                .catch((error) => {
                    reject(error);
                });
        });
    }

    getNotes(memberUuid) {

        return new Promise( (resolve, reject) => {

            const url = 'clients/' + memberUuid + '/notes';

            axios.get(url)
                .then((response) => {

                    if (response.status === 200) {

                        let notes = [];

                        response.data.forEach((note) => {
                            notes.push(new Note(note.uuid, note.user, note.note, new Date(note.date), note.noteTypeId, note.deleted, note.userId));
                        });

                        resolve(notes);
                    }
                    else {
                        reject(response.status);
                    }
                })
                .catch((error) => {
                    reject(error);
                });
        });
    }

    newNote(memberUuid, note) {

        return new Promise( (resolve, reject) => {

            const url = 'clients/' + memberUuid + '/note';
            let bodyFormData = new FormData();
            bodyFormData.set("note", note.note);
            bodyFormData.set("note_type_id", note.noteTypeId);

            axios.post(url, bodyFormData)
                .then((response) => {

                    if (response.status === 201) {
                        resolve();
                    }
                    else {
                        reject(response.status);
                    }
                })
                .catch((error) => {
                    reject(error);
                });
        });
    }

    updateNote(memberUuid, noteUuid, note) {
      return new Promise( (resolve, reject) => {

        const url = 'clients/' + memberUuid + '/clientnote/' + noteUuid;
        let bodyFormData = new FormData();
        bodyFormData.set("note", note.note);

        axios.post(url, bodyFormData)
          .then((response) => {

            if (response.status === 201) {
              resolve();
            }
            else {
              reject(response.status);
            }
          })
          .catch((error) => {
            reject(error);
          });
      });
    }

    deleteNote(memberUuid, uuid, noteTypeId) {

        return new Promise( (resolve, reject) => {

            const url = 'clients/' + memberUuid + '/clientnote/' + uuid;

            axios.delete(url)
                .then((response) => {

                    if (response.status === 200) {
                        resolve();
                    }
                    else {
                        reject(response.status);
                    }
                })
                .catch((error) => {
                    reject(error);
                });
        });
    }

}
